"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyles = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@emotion/react");

var _margin = _interopRequireDefault(require("./margin"));

var _cssVariables = _interopRequireDefault(require("./cssVariables"));

var _suiOverrides = _interopRequireDefault(require("./suiOverrides"));

var _boxShadow = _interopRequireDefault(require("./boxShadow"));

var _base = _interopRequireDefault(require("./base"));

var _theme = _interopRequireDefault(require("./ckeditor/theme.styles"));

var _content = _interopRequireDefault(require("./ckeditor/content.styles"));

var GlobalStyles = function GlobalStyles() {
  var theme = (0, _react2.useTheme)();
  return (0, _jsxRuntime.jsx)(_react2.Global, {
    styles: [(0, _margin["default"])(theme), (0, _boxShadow["default"])(theme), (0, _cssVariables["default"])(theme), (0, _suiOverrides["default"])(theme), (0, _base["default"])(theme), (0, _theme["default"])(theme), (0, _content["default"])(theme), process.env.NODE_ENV === "production" ? "" : ";label:GlobalStyles;"]
  });
};

exports.GlobalStyles = GlobalStyles;
//# sourceMappingURL=index.js.map